import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {
  // HeaderNotificationsMenu,
  HeaderUserMenu, 
  // Search, 
} from '../../../partials'
import { ThemeModeSwitcher } from '../../../partials/layout/theme-mode/ThemeModeSwitcher'
import {useLayout} from '../../core'
import { NavbarSoftphone } from './NavbarSoftphone'
import { AgentControls } from './AgentControls'
import { useAgentContext } from '../../../../app/modules/apps/call/AgentContext'
import { useAuth } from '../../../../app/modules/auth'
import { useThemeMode } from '../../../partials/layout/theme-mode/ThemeModeProvider'
import { Coffee, PlayCircle, ChevronDown, Clock, Layers, LogOut, PhoneIncoming, PhoneOutgoing, Users, PhoneCall, CheckCircle, XCircle, Activity } from 'lucide-react';

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom text-white btn-active-light btn-active-color-primary w-35px h-35px hover-elevate-up'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const {config} = useLayout()
  const { currentUser } = useAuth()
  const { mode } = useThemeMode()
  const isDark = mode === 'dark' || document.documentElement.getAttribute('data-bs-theme') === 'dark'
  const [hasIncomingCall, setHasIncomingCall] = useState(false)

  // Only show softphone/agent controls for users with agent role
  const isAgent = currentUser?.roles?.some((r: any) =>
    (r?.name || r?.roleName || r || '').toString().toLowerCase().includes('agent')
  ) ?? false

  useEffect(() => {
    const onIncoming = () => setHasIncomingCall(true)
    const onEnd = () => setHasIncomingCall(false)
    window.addEventListener('incoming-call', onIncoming)
    window.addEventListener('call-ended', onEnd)
    return () => {
      window.removeEventListener('incoming-call', onIncoming)
      window.removeEventListener('call-ended', onEnd)
    }
  }, [])

  const {
    isLoggedIn, isAux, selectedCampaign, setSelectedCampaign,
    campaigns, auxReasons, seconds, handleLogin, handleLogout,
    handleAuxAction, data, campaignMetrics, activeCampaignData
  } = useAgentContext();

  const [showAuxMenu, setShowAuxMenu] = useState(false);
  const [showCampaignMenu, setShowCampaignMenu] = useState(false);
  const [showQueueMenu, setShowQueueMenu] = useState(false);




  return (
    <div className='app-navbar flex-shrink-0' style={{ overflow: 'visible' }}>
      {/* ITEM YANG DIHAPUS: 
         Icon Activity Log (id='sc_activities_toggle') sudah dibuang dari sini.
      */}

      {/* STAT CHIPS (Total Leads, Calls, Connected, Success) */}
      {isAgent && (
        <div className={clsx('app-navbar-item', itemClass, 'd-none d-xl-flex me-3')}>
          <div className='d-none d-xl-flex align-items-center gap-3'>
            {[
              { label: 'Total Leads', value: campaignMetrics?.totalLeads ?? 0, icon: 'bi-people-fill', color: 'rgb(96, 165, 250)', minW: '100px' },
              { label: 'Calls', value: campaignMetrics?.totalCalls ?? 0, icon: 'bi-telephone-outbound-fill', color: 'rgb(251, 191, 36)', minW: '85px' },
              { label: 'Connected', value: campaignMetrics?.connected ?? 0, icon: 'bi-headset', color: 'rgb(129, 140, 248)', minW: '95px' },
              { label: 'Success', value: campaignMetrics?.success ?? 0, icon: 'bi-check-circle-fill', color: 'rgb(52, 211, 153)', minW: '88px' },
            ].map((s) => (
              <div
                key={s.label}
                className='d-flex flex-column justify-content-between rounded-3'
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.12)',
                  padding: '6px 14px',
                  minWidth: s.minW,
                  height: '42px',
                }}
              >
                <div className='d-flex align-items-center gap-2'>
                  <i className={`bi ${s.icon}`} style={{ fontSize: 11, color: s.color }}></i>
                  <span
                    className='fw-bold text-white opacity-75 text-uppercase'
                    style={{ fontSize: 9.5, letterSpacing: '0.5px', whiteSpace: 'nowrap' }}
                  >
                    {s.label}
                  </span>
                </div>
                <div className='fw-boldest text-white lh-1' style={{ fontSize: 16, paddingLeft: '1px' }}>
                  {s.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Separator between stats and softphone */}
      {isAgent && (
        <div
          className='d-none d-xl-flex align-self-center mx-2 flex-shrink-0'
          style={{ width: 1, height: 30, background: 'rgba(255,255,255,0.15)' }}
        />
      )}

      {/* SOFTPHONE UI - only for agents */}
      {isAgent && (
        <div className={clsx('app-navbar-item', itemClass, 'd-none d-xl-flex')}>
          <NavbarSoftphone forceDark={true} />
        </div>
      )}

      {/* Separator between softphone and agent controls */}
      {isAgent && (
        <div className="d-none d-xl-flex align-self-center mx-1 flex-shrink-0"
          style={{ width: 1, height: 28, background: 'rgba(255,255,255,0.12)' }} />
      )}

      {/* AGENT CONTROLS - full on xl+, abbreviated on lg-xl */}
      {isAgent && (
        <>
          {/* Full desktop */}
          <div className={clsx('app-navbar-item', itemClass, 'd-none d-xl-flex')}>
            <AgentControls forceDark={true} />
          </div>
          {/* Mobile & Tablet abbreviated (xs – xl): icon-only pills */}
          <div className={clsx('app-navbar-item', itemClass, 'd-flex d-xl-none align-items-center gap-2')}>
            <AgentControls className="agent-compact" forceDark={true} variant="timer-only" />
          </div>
        </>
      )}

      {/* THEME MODE SWITCHER */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom', btnClass)} />
      </div>

      {/* USER MENU (AVATAR) */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='' />
        </div>
        <HeaderUserMenu />
      </div>

      {/* MOBILE MENU TOGGLE */}
      {/* {config.app?.header?.default?.menu?.display && (
        // <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
        //   <div
        //     className='btn btn-icon btn-active-color-primary w-35px h-35px'
        //     id='sc_app_header_menu_toggle'
        //   >
        //     <KTIcon iconName='text-align-left' className={btnIconClass} />
        //   </div>
        // </div>
      )} */}
    </div>
  )
}

export {Navbar}
